import { useMemo } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import { APP_SIDEBAR_WIDTH, WEB_SIDEBAR_BREAKPOINT } from './breakpoints';
import {
  CONTENT_WIDE_BREAKPOINT,
  contentMaxWidthForVariant,
  type ScreenLayoutVariant,
} from './breakpoints';

export type ContentLayoutMode = {
  width: number;
  /** Panel principal >= 768 — tablas, multi-columna (descuenta sidebar en web shell). */
  layoutWide: boolean;
  /** web && width >= 960 — app sidebar visible. */
  layoutWebShell: boolean;
  contentMaxWidth: number | undefined;
};

export function getShellMainPanelWidth(windowWidth: number): number {
  if (Platform.OS === 'web' && windowWidth >= WEB_SIDEBAR_BREAKPOINT) {
    return windowWidth - APP_SIDEBAR_WIDTH;
  }
  return windowWidth;
}

export function getContentLayoutMode(
  width: number,
  variant: ScreenLayoutVariant = 'default'
): ContentLayoutMode {
  const layoutWebShell = Platform.OS === 'web' && width >= WEB_SIDEBAR_BREAKPOINT;
  const panelWidth = getShellMainPanelWidth(width);
  const variantCap = contentMaxWidthForVariant(variant);
  const contentMaxWidth =
    variantCap != null
      ? layoutWebShell
        ? Math.min(variantCap, panelWidth)
        : variantCap
      : undefined;

  return {
    width,
    layoutWide: panelWidth >= CONTENT_WIDE_BREAKPOINT,
    layoutWebShell,
    contentMaxWidth,
  };
}

export function useContentLayout(variant: ScreenLayoutVariant = 'default'): ContentLayoutMode {
  const { width } = useWindowDimensions();
  return useMemo(() => getContentLayoutMode(width, variant), [width, variant]);
}

export type TabWorkspaceLayoutMode = {
  width: number;
  layoutWide: boolean;
  layoutWebShell: boolean;
};

/** Tabs operativos (POS, Catálogo, Stock, Informes): full panel width, no contentMaxWidth cap. */
export function useTabWorkspaceLayout(): TabWorkspaceLayoutMode {
  const { width } = useWindowDimensions();
  return useMemo(
    () => ({
      width,
      layoutWide: getShellMainPanelWidth(width) >= CONTENT_WIDE_BREAKPOINT,
      layoutWebShell: Platform.OS === 'web' && width >= WEB_SIDEBAR_BREAKPOINT,
    }),
    [width]
  );
}
